import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { mapContactItem, perPageItem } from '../../../utils'

import contact from './contact'
import org from './org'
import attachment from './attachment'
import remark from './remark'

const state = {
  list: [],
  currentPage: 1,
  hasMore: true,
  tagged: {
    // 如需：contactList -> contact -> taggedList -> contact -> taggedList 回退不刷新，则需要在这里使用 id -> { list, currentPage, hasMore } 键值对
    list: [],
    currentPage: 1,
    hasMore: true
  }
}

/*
const sampleList = [
  {
    avatar: 'http://www.lingxi360.com/Uploads/picture/20160617/5763aaef1394f-225-225-i.png',
    name: '王小华',
    phone: '12312341234'
  }, {
    avatar: 'http://www.lingxi360.com/Uploads/picture/20160617/5763aaef1394f-225-225-i.png',
    name: '王小华',
    phone: '12312341234'
  }, {
    avatar: 'http://www.lingxi360.com/Uploads/picture/20160617/5763aaef1394f-225-225-i.png',
    name: '王小华',
    phone: '12312341234'
  }
]
*/

const actions = {
  [aTypes.CONTACT_GET_LIST] ({ commit, dispatch }, { page, append, roleId, tagId, orgId, withRelation }) {
    commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_LIST, loading: true })
    api.contact.getList({
      success (res) {
        const list = res.body.data.map(mapContactItem)
        const pagination = res.body.meta.pagination
        const hasMore = pagination.current_page < pagination.total_page
        commit(mTypes.SET_LOADING, { key: aTypes.CONTACT_GET_LIST, loading: false })

        if (roleId || tagId || orgId) {
          commit(mTypes.SET_LOADED_ID_OF_CONTACT_TAGGED_LIST, { roleId, tagId, orgId })
        }

        if (roleId || tagId) {
          commit(mTypes.CONTACT_SET_TAGGED_LIST, { list, page, hasMore, append })
          dispatch(aTypes.ZHUGE_TRACK, { event: '到达任意标签列表页' })
        } else {
          commit(mTypes.SET_LOADED_OF_CONTACT_LIST, true)
          commit(mTypes.CONTACT_SET_LIST, { list, page, hasMore, append })
          dispatch(aTypes.ZHUGE_TRACK, { event: '到达联系人列表页', data: { '联系人数': pagination.total }})
        }
      },
      commit
    }, { page, perPage: perPageItem, roleId, tagId, orgId, withRelation })
  }
}

const mutations = {
  [mTypes.CONTACT_SET_LIST] (state, { list, page, hasMore, append }) {
    if (append) {
      state.list = state.list.concat(list)
    } else {
      state.list = list
    }
    state.currentPage = page
    state.hasMore = hasMore
  },
  [mTypes.CONTACT_SET_TAGGED_LIST] (state, { list, page, hasMore, append }) {
    if (append) {
      state.tagged.list = state.tagged.list.concat(list)
    } else {
      state.tagged.list = list
    }
    state.tagged.currentPage = page
    state.tagged.hasMore = hasMore
  }
}

export default {
  modules: {
    contact,
    org,
    attachment,
    remark
  },
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contact/index.js